import { render, staticRenderFns } from "./tabelaClientes.vue?vue&type=template&id=0b479a8e&scoped=true&"
import script from "./tabelaClientes.vue?vue&type=script&lang=js&"
export * from "./tabelaClientes.vue?vue&type=script&lang=js&"
import style0 from "./tabelaClientes.vue?vue&type=style&index=0&id=0b479a8e&scoped=true&lang=css&"
import style1 from "./tabelaClientes.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b479a8e",
  null
  
)

export default component.exports